function hoverGradientAnimation() {
  // Fixed gradient and steps as specified
  const gradient = 'linear-gradient(90deg, #FCC979 0, #7DF9F4 42.88%, #9776FE 77.13%, #D588EA 100%)';
  const steps = 16; // Number of steps for the animation
  
  // Create the keyframes for forward animation
  let forwardKeyframes = '';
  for (let i = 0; i <= steps; i++) {
    const percent = (i / steps) * 100;
    const angle = 90 + (i * 360) / steps;
    forwardKeyframes += `${percent}% { background: linear-gradient(${angle}deg, #FCC979 0, #7DF9F4 42.88%, #9776FE 77.13%, #D588EA 100%); }\n`;
  }
  
  // Create the keyframes for reverse animation
  let reverseKeyframes = '';
  for (let i = 0; i <= steps; i++) {
    const percent = (i / steps) * 100;
    const angle = 90 - (i * 360) / steps;
    reverseKeyframes += `${percent}% { background: linear-gradient(${angle}deg, #FCC979 0, #7DF9F4 42.88%, #9776FE 77.13%, #D588EA 100%); }\n`;
  }
  
  // Create a style element and append the keyframes
  const styleElement = document.createElement('style');
  styleElement.textContent = `
    @keyframes gradientRotateForward {
      ${forwardKeyframes}
    }
    
    @keyframes gradientRotateReverse {
      ${reverseKeyframes}
    }
    
    .buttonColourBorder::before {
      transition: animation 0.3s ease;
    }
    
    .buttonColourBorder.hover-in::before {
      animation: gradientRotateForward 2s linear forwards;
    }
    
    .buttonColourBorder.hover-out::before {
      animation: gradientRotateReverse 2s linear forwards;
    }
  `;
  
  document.head.appendChild(styleElement);
  
  const buttons = document.querySelectorAll('.buttonColourBorder');
  buttons.forEach(button => {
    button.addEventListener('mouseenter', () => {
      button.classList.remove('hover-out');
      button.classList.add('hover-in');
    });
    
    button.addEventListener('mouseleave', () => {
      button.classList.remove('hover-in');
      button.classList.add('hover-out');
    });
  });
}

document.addEventListener('DOMContentLoaded', hoverGradientAnimation);